var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import './style.scss';
import pubsub from "@viewlift/pubsub";
import { closeIcon } from "../../../images/icon";
var CustomModalWrapper = function (_a) {
    var Component = _a.Component, props = _a.props;
    var _b = __read(useState(true), 2), isActive = _b[0], setIsActive = _b[1];
    var handleClick = function () {
        setIsActive(false);
        sessionStorage.removeItem("splashLoginEmail");
        pubsub.publish('verifyOtp', { screen: false, type: '' }); // reset verifyOtp state
    };
    return (React.createElement(React.Fragment, null, isActive && React.createElement("div", { className: "popup-header-container" },
        React.createElement("div", { className: "popup-header-wrapper" },
            React.createElement("div", { className: "close-wrapper", onClick: handleClick }, closeIcon()),
            React.createElement(Component, __assign({}, props))))));
};
export default CustomModalWrapper;
